import RoutePath from 'shared/utils/namedUrls';

const basePath = '/favorites/';

export default {
  allFavoritePreceptors: new RoutePath(`${basePath}`),
};
